var map = {
	"./better": "82Ee",
	"./better.jsx": "82Ee",
	"./globalcitizen": "Rn5D",
	"./globalcitizen.jsx": "Rn5D",
	"./knowyourvalue": "DyXw",
	"./knowyourvalue.jsx": "DyXw",
	"./leftfield": "KNOl",
	"./leftfield.jsx": "KNOl",
	"./mach": "hjuk",
	"./mach.jsx": "hjuk",
	"./msnbc": "aVKD",
	"./msnbc.jsx": "aVKD",
	"./news": "HfBk",
	"./news.jsx": "HfBk",
	"./sponsoredcontent": "s0iP",
	"./sponsoredcontent.jsx": "s0iP",
	"./telemundonoticias": "D3bB",
	"./telemundonoticias.jsx": "D3bB",
	"./think": "DX6U",
	"./think.jsx": "DX6U",
	"./today": "cBAH",
	"./today.jsx": "cBAH"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "1GTe";
module.exports = webpackContext;